<template>
    <div class="seller-order-send">
        <div class="common-header-wrap">
            <mt-header title="订单发货" class="common-header">
                <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
            </mt-header>
        </div>
        <!-- header -->

        <div class="main-content">
            <div class="daddress_info" @click="goAddress">
                <div class="top-wrapper">
                    <flex-line class="selected-wrapper" v-if="daddress_info" :show-border="true">
                        <div class="line">
                            <i class="icon iconfont">&#xe6d3;</i>
                            <div class="line-content">
                                <div class="title-wrapper">
                                    <label class="title">{{daddress_info.seller_name}}</label>
                                    <label class="title" style="margin-left:1rem;">{{daddress_info.daddress_telphone}}</label>
                                    <label class="default" v-if="daddress_info.daddress_isdefault">默认</label>
                                </div>
                                <div class="desc address-text">{{daddress_info.area_info}}{{daddress_info.daddress_detail}}</div>
                            </div>
                        </div>
                    </flex-line>
                    <div v-else class="unselected-wrapper">
                        <label class="desc">您还没有发货地址，点击这里添加。</label>
                    </div>
                </div>
            </div>

            <div class="cart-subtotal">
                <div @click="popupExpress=true">
                    <flex-line class="menu-item" :is-link="true" :show-border="true"><span class="line-name">物流公司</span><span slot="right">{{express_name}}</span></flex-line>
                </div>
                <div class="message" v-if="shipping_express_id!=0">
                    <flex-line class="field-line" :show-border="true"><span class="field-name">物流单号</span><div class="field-line-right" slot="right"><input class="field-input" v-model="shipping_code" /></div></flex-line>
                </div>
            </div>
            <div class="pt-10 pb-10"><div class="common-btn ds-button-large" @click="submit">提交</div></div>
        </div>
        <mt-popup v-model="popupExpress" position="right" class="common-popup-wrapper">
            <div class="common-header-wrap">
                <mt-header title="物流公司" class="common-header">
                    <mt-button slot="left" icon="back" @click="popupExpress=false"></mt-button>
                    <div class="common-btn btn" slot="right" @click="setExpress(0,'无需物流')">无需物流</div>
                </mt-header>
            </div>
            <div class="common-popup-content" id="content">
                <div class="input-wrapper">
                    <input class="input" ref="input" type="text" v-model="keyword" placeholder="输入关键词" @keydown.enter="searchExpress()"/>
                </div>
                <div v-if="!keyword || !resultList">

                    <div class="select-wrapper" v-if="my_express && my_express.length">
                        <div class="title">我的物流</div>
                        <div class="content">
                            <div class="item" v-for="(item,index) in my_express" :key="index" @click="setExpress(item.express_id,item.express_name)"><span class="text">{{item.express_name}}</span></div>
                        </div>
                    </div>
                    <div class="select-wrapper" v-if="hot_express && hot_express.length">
                        <div class="title">常用物流</div>
                        <div class="content">
                            <div class="item" v-for="(item,index) in hot_express" :key="index" @click="setExpress(item.express_id,item.express_name)"><span class="text">{{item.express_name}}</span></div>
                        </div>
                    </div>
                    <div class="sort-list" id="ID">
                        <div v-for="(group,index) in all_express" :key="index">
                            <div class="letter" :id="group.letter">{{group.letter}}</div>
                            <div class="content">
                                <div class="item" v-for="(item,key) in group.list" :key="key" @click="setExpress(item.express_id,item.express_name)">{{item.express_name}}</div>
                            </div>
                        </div>
                    </div>

                </div>
                <div v-else>
                    <div class="sort-list">
                        <div class="content" v-if="resultList.length">
                            <div class="item" v-for="(item,key) in resultList" :key="key" @click="setExpress(item.express_id,item.express_name)">{{item.express_name}}</div>
                        </div>
                        <empty-record v-else></empty-record>
                    </div>
                </div>
                <div class="nav-list" v-if="!keyword || !resultList">
                    <div class="item" v-for="(item,index) in all_express" :key="index" @click="scrollTo(item.letter)">{{item.letter}}</div>
                </div>
            </div>
        </mt-popup>

    </div>
</template>

<script>
import { getExpressList, getExpressInfo } from '../../../api/sellerExpress'
import { sendOrder } from '../../../api/sellerOrder'
import { Toast, MessageBox, Indicator } from 'mint-ui'
import EmptyRecord from '../../EmptyRecord'
import flexLine from '../../flexLine'
export default {
  components: {
    flexLine,
    EmptyRecord
  },
  name: 'SellerOrderSend',
  data () {
    return {
      keyword: '',
      order_id: this.$route.query.order_id,
      daddress_info: false,
      shipping_code: '',
      shipping_express_id: 0,
      express_name: '无需物流',
      popupExpress: false,
      all_express: [],
      hot_express: [],
      my_express: [],
      resultList: false
    }
  },

  mounted () {
  },
  computed: {

  },
  created: function () {
    let _this = this
    getExpressInfo(this.order_id).then(res => {
      this.daddress_info = res.result.daddress_info
    }).catch(function (error) {
      Toast(error.message)
      if (error.code == '12002') {
        _this.goAddress()
      }
    })
    getExpressList(this.order_id).then(res => {
      this.all_express = res.result.all_express
      this.my_express = res.result.my_express
      this.hot_express = res.result.hot_express
    }).catch(function (error) {
      Toast(error.message)
    })
  },

  methods: {
    setExpress (id, name) {
      this.shipping_express_id = id
      this.express_name = name
      this.popupExpress = false
    },
    scrollTo (str) {
      // if (str != '#') {
      document.getElementById(str).scrollIntoView()
      // } else {
      //     document.getElementById('content').scrollIntoView()
      // }
    },
    searchExpress () {
      if (!this.keyword) {
        this.resultList = false
      } else {
        var resultList = []
        for (var i in this.all_express) {
          for (var j in this.all_express[i].list) {
            var str = this.all_express[i].list[j].express_name
            if (str.search(this.keyword) != -1) {
              resultList.push(this.all_express[i].list[j])
            }
          }
        }
        this.resultList = resultList
      }
    },
    goAddress () {
      if (this.daddress_info) {
        this.$router.push({ name: 'SellerAddressList' })
      } else {
        this.$router.push({
          name: 'SellerAddressForm',
          query: {
            action: 'add',
            isFromCheckout: true,
            goBackLevel: -1
          }
        })
      }
    },
    submit () {
      if (this.shipping_express_id == 0) {
        this.shipping_express_id = ''
      }
      if (!this.daddress_info) {
        Toast('请先添加发货地址')
        return
      }
      if (this.shipping_express_id != '' && this.shipping_code == '') {
        Toast('请先填写物流单号')
        return
      }
      sendOrder(this.order_id, this.shipping_express_id, this.shipping_code, this.daddress_info.daddress_id).then(res => {
        Toast(res.message)
        this.$router.go(-1)
      }).catch(function (error) {
        Toast(error.message)
      })
    }
  }
}
</script>
<style  lang="scss" scoped>
.common-header{
        .btn{background: #000;color: #fff;box-shadow: 0px 2px 4px #d2d2d2;}
    }
    .main-content{background: #fff;padding:0 $pageSpace}
    .daddress_info{display: flex;
        .line{display: flex;
            .line-content{flex:1}
        }
        .top-wrapper {
            flex: 1;
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;
            background-color: #fff;
        }
        .title-wrapper {
            height: 1rem;
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;
        }
        .icon {
            font-size:$h1;
            margin-right: .2rem;
            color:$primaryColor
        }
        .title {
        }
        .default {
            width: 1.4rem;
            margin-left: 0.5rem;
            margin-right: 0.5rem;
            border: 1px solid #e93b3d;
            color: $primaryColor;
            font-size:$h6;
            text-align: center;
            border-radius: 0.1rem;
        }
        .desc {
            color: $descTextColor;
        }
        .address-text {
            margin-top: .3rem;
            font-weight: normal;
        }
        .selected-wrapper{
            flex: 1;
            padding:1rem 0;
        }
        .unselected-wrapper {
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
        }
        .indicator {
            height: 0.6rem;
            margin-left: 0.5rem;
            margin-right: $pageSpace;
        }
        .line-wrapper {
            background:#eee;
            // position: relative;
            left: 0;
            right: 0;
            bottom: 0;
            width: 100%;
            height: 0.1rem;
        }
    }
    .nav-list{position: fixed;right:0;top:5.5rem;font-size:$fontSize;text-align: center;bottom:4rem;
        .item{height: 4.347826%;width:1rem;}
    }
    .input-wrapper{padding:1rem;position:relative;font-size:$subFontSize;text-align: center;
        .placeholder{position: absolute;top:1rem;left:0;width:100%;color:#999;line-height: 1.5rem;}
        .input{width:100%;height: 1.5rem;line-height: 1.5rem;border-radius: 1.5rem;border:1px solid #e1e1e1;text-align: center;}
    }
    .select-wrapper{
        .title{padding:1rem;font-size:$subFontSize;color:#666;padding-top:0}
        .content{overflow:hidden;padding:0 .5rem;
            .item{float:left;width:25%;padding:0 .5rem;box-sizing:border-box;font-size:$subFontSize;height:1.5rem;line-height:1.5rem;margin-bottom:1rem;
                .text{border:1px solid #e1e1e1;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:block;border-radius:.2rem;text-align:center;background:#fff;
                }
            }
        }
    }
    .sort-list{padding:0 1rem;font-size:$subFontSize;
        .letter{}
        .content{padding-bottom:1rem;
            .item{line-height:2rem;border-bottom:1px solid #e1e1e1}
        }
    }
</style>
